import React from "react";
import classes from "./Layout.module.css";
import { NavLink } from "react-router-dom";
import enflag from "../../Assets/Images/Flags/EN.png"
import deflag from "../../Assets/Images/Flags/DE.png"
import jpflag from "../../Assets/Images/Flags/JP.png"
import esflag from "../../Assets/Images/Flags/ES.png"
import frflag from "../../Assets/Images/Flags/FR.png"
import itflag from "../../Assets/Images/Flags/IT.png"
import krflag from "../../Assets/Images/Flags/KR.png"
import cnflag from "../../Assets/Images/Flags/CN.png"

const Layout = props => {
    return (
        <>
        <header>
            <div className={classes.Flags}>
                <ul>
                    <li onClick={() => props.changeLanguage('en')}><img src={enflag} alt="English" height="20px" /></li>
                    <li onClick={() => props.changeLanguage('de')}><img src={deflag} alt="Deutsch" height="20px" /></li>
                    <li onClick={() => props.changeLanguage('es')}><img src={esflag} alt="Español" height="20px" /></li>
                    <li onClick={() => props.changeLanguage('fr')}><img src={frflag} alt="Français" height="20px" /></li>
                    <li onClick={() => props.changeLanguage('it')}><img src={itflag} alt="Italiano" height="20px" /></li>
                    <li onClick={() => props.changeLanguage('jp')}><img src={jpflag} alt="日本語" height="20px" /></li>
                    <li onClick={() => props.changeLanguage('kr')}><img src={krflag} alt="한국" height="20px" /></li>
                    <li onClick={() => props.changeLanguage('cn')}><img src={cnflag} alt="汉字简化方案" height="20px" /></li>
                </ul>
            </div>
            <nav className={classes.Nav}>
                <ul>
                    <li><NavLink to="/" exact activeClassName={classes.Active} className={classes.Link}>SWSH - Seed Checker</NavLink></li>
                    <li><NavLink to="/event/" activeClassName={classes.Active} className={classes.Link}>SWSH - Event List</NavLink></li>
                    <li><NavLink to="/dens/" activeClassName={classes.Active} className={classes.Link}>SWSH - Den Overview</NavLink></li>
                    <li><NavLink to="/maps/" activeClassName={classes.Active} className={classes.Link}>SWSH - Wild Area Map</NavLink></li>
                    <li><NavLink to="/underground/" activeClassName={classes.Active} className={classes.Link}>BDSP - Underground</NavLink></li>
                </ul>
            </nav>
        </header>
        <main className={classes.Content}>
            {props.children}
        </main>
        </>
    );
}

export default Layout;